import React, { useState } from 'react';
import { brandGradients, brandTextGradients } from '../theme/palette';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    service: '',
    location: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Simulate form submission
    setTimeout(() => {
      alert('Thank you for contacting RLDS Pvt Ltd! We will get back to you within 24 hours with a detailed consultation.');
      setFormData({ 
        name: '', 
        email: '', 
        phone: '', 
        company: '', 
        service: '', 
        location: '', 
        message: '' 
      });
      setIsSubmitting(false);
    }, 2000);
  };

  const offices = [
    {
      name: 'Head Office - Kurnool',
      address: ['RLDS Pvt Ltd', 'Kurnool, Andhra Pradesh'],
      icon: 'fas fa-building',
      color: 'from-blue-600 to-blue-700'
    },
    {
      name: 'Hyderabad Branch',
      address: ['Regional Office', 'Hyderabad, Telangana'],
      icon: 'fas fa-building',
      color: 'from-purple-600 to-purple-700'
    },
    {
      name: 'Bangalore Branch',
      address: ['Regional Office', 'Bangalore, Karnataka'],
      icon: 'fas fa-building',
      color: 'from-green-600 to-green-700'
    },
    {
      name: 'Chennai Branch',
      address: ['Regional Office', 'Chennai, Tamil Nadu'],
      icon: 'fas fa-building',
      color: 'from-orange-600 to-red-600'
    }
  ];

  const services = [
    'Credit Verification',
    'Address Verification',
    'Employment Verification',
    'Background Checks',
    'Due Diligence',
    'Premarital Verification',
    'Business Verification',
    'Other Services'
  ];

  const locations = [
    'Andhra Pradesh',
    'Telangana',
    'Karnataka',
    'Tamil Nadu'
  ];

  return (
    <section id="contact" className="py-20 lg:py-16 bg-white">
  <div className="container">
        {/* Section Header */}
        <div className="text-center mb-20 animate-on-scroll">
          <span className="text-[#00a4f4] text-xl font-bold"style={{ color: '#ff70a6' }}>
            Get in Touch
          </span>
          <h2 className="text-4xl lg:text-6xl font-black text-gray-800 mt-4 mb-8 leading-tight">
            Contact RLDS Pvt Ltd for
            <span className="block text-blue-600">Professional Services</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
            Ready to experience professional verification and due diligence services? Contact us today 
            for confidential, timely, and accurate solutions across South India.
          </p>
        </div>

  <div className="grid lg:grid-cols-3 gap-16 items-stretch">
          {/* Contact Form */}
          <div className="lg:col-span-2 animate-on-scroll">
            <div className="bg-gradient-to-br from-white to-blue-50 rounded-3xl p-8 lg:p-12 shadow-1xl border border-blue-100 h-full">
              <div className="flex items-center mb-8">
                <div className="w-12 h-12 rounded-xl flex items-center justify-center mr-4" style={{ background: brandGradients.panel }}>
                  <i className="fas fa-envelope text-white text-lg"></i>
                </div>
                <div>
                  <h3 className="text-3xl font-bold text-gray-800">Send us a Message</h3>
                  <p className="text-gray-600">We'll respond within 24 hours</p>
                </div>
              </div>

              <form onSubmit={handleSubmit} className="space-y-6">
                {/* Personal Info */}
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="name" className="block text-gray-700 font-semibold mb-3">
                      Full Name *
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-4 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-gray-800"
                      placeholder="Your full name"
                    />
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-gray-700 font-semibold mb-3">
                      Email Address *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-4 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-gray-800"
                      placeholder="your@email.com"
                    />
                  </div>
                </div>

                {/* Contact & Company */}
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="phone" className="block text-gray-700 font-semibold mb-3">
                      Phone Number *
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-4 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-gray-800"
                      placeholder="+91 XXXXX XXXXX"
                    />
                  </div>
                  <div>
                    <label htmlFor="company" className="block text-gray-700 font-semibold mb-3">
                      Company/Organization
                    </label>
                    <input
                      type="text"
                      id="company"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      className="w-full px-4 py-4 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-gray-800"
                      placeholder="Your company name"
                    />
                  </div>
                </div>

                {/* Service & Location */}
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="service" className="block text-gray-700 font-semibold mb-3">
                      Service Required *
                    </label>
                    <select
                      id="service"
                      name="service"
                      value={formData.service}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-4 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-gray-800"
                    >
                      <option value="">Select a service</option>
                      {services.map((service, idx) => (
                        <option key={idx} value={service}>{service}</option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label htmlFor="location" className="block text-gray-700 font-semibold mb-3">
                      Location/State
                    </label>
                    <select
                      id="location"
                      name="location"
                      value={formData.location}
                      onChange={handleChange}
                      className="w-full px-4 py-4 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-gray-800"
                    >
                      <option value="">Select location</option>
                      {locations.map((location, idx) => (
                        <option key={idx} value={location}>{location}</option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Message */}
                <div>
                  <label htmlFor="message" className="block text-gray-700 font-semibold mb-3">
                    Message/Requirements *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="4"
                    className="w-full px-4 py-4 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all resize-none text-gray-800"
                    placeholder="Please describe your verification requirements, timeline, and any specific details..."
                  ></textarea>
                </div>

                {/* Submit Button */}
                <button 
                  type="submit" 
                  disabled={isSubmitting}
                  className="w-full text-white text-lg font-bold py-4 px-8 rounded-xl transition-all duration-300 transform hover:scale-105 shadow-1xl disabled:opacity-70 disabled:cursor-not-allowed"
                  style={{ background: brandGradients.panel }}
                >
                  {isSubmitting ? (
                    <span className="flex items-center justify-center">
                      <i className="fas fa-spinner fa-spin mr-3"></i>
                      Sending Message...
                    </span>
                  ) : (
                    <span className="flex items-center justify-center">
                      <i className="fas fa-paper-plane mr-3"></i>
                      Send Message
                    </span>
                  )}
                </button>

                <p className="text-gray-600 text-sm text-center">
                  <i className="fas fa-shield-alt mr-2"></i>
                  Your information is completely confidential and secure.
                </p>
              </form>
            </div>
          </div>

          {/* Contact Information */}
          <div className="animate-on-scroll">
            <div className="bg-white rounded-3xl p-6 lg:p-8 shadow-1xl border border-gray-100 h-full flex flex-col">
              <h3 className="text-3xl font-bold text-gray-800 mb-6">Our Offices</h3>

              <div className="flex-1 grid grid-cols-1 gap-6 overflow-y-auto pr-1">
                {offices.map((office, index) => (
                  <div key={index} className="bg-gradient-to-br from-white to-blue-50 rounded-2xl p-6 shadow-1xl transition-all duration-300 border border-blue-100">
                    <div className="flex items-center gap-4">
                      <div className={`w-12 h-12 bg-gradient-to-r ${office.color} rounded-xl flex items-center justify-center flex-shrink-0`}>
                        <i className={`${office.icon} text-white text-lg`}></i>
                      </div>
                      <div className="flex-grow">
                        <h4 className="font-bold text-gray-800 text-lg mb-1">{office.name}</h4>
                        <div className="text-gray-600 text-sm space-y-1">
                          {office.address.map((line, idx) => (
                            <p key={idx}>{line}</p>
                          ))}
                        </div>
                        {/* No direct phone/email per request; users can use the form above */}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Optional: footer area for quick contact or notes */}
            </div>
          </div>
        </div>

        {/* Coverage Map */}
        {/* <div className="mt-20 animate-on-scroll">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-800 mb-4">Our Service Coverage</h3>
            <p className="text-lg text-gray-600">Serving clients across South India with professional excellence</p>
          </div>

          <div className="grid md:grid-cols-4 gap-6">
            {['Andhra Pradesh', 'Telangana', 'Karnataka', 'Tamil Nadu'].map((state, index) => (
              <div key={index} className="text-center p-6 bg-white rounded-2xl shadow-1xl hover:shadow-1xl transition-all duration-300">
                <div className="w-16 h-16 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-map-marker-alt text-white text-xl"></i>
                </div>
                <h4 className="font-bold text-gray-800 text-lg">{state}</h4>
                <p className="text-gray-600 text-sm">Multiple city coverage</p>
              </div>
            ))}
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default Contact;